import React from 'react';
import { EventsDescriptionCard } from './EventsDescriptionCard';

type Props = {};

export const EventsHeader: React.FC<Props> = ({}) => {
    return (
        <div className="events-description-cards-container">
            <EventsDescriptionCard
                title={'Weeklies'}
                description={`
                Weekly Tournaments are free competitions for our most popular recruiting games, 
                including Rocket League, Valorant, and other titles. Each tournament features a $100 
                prize and is a great way to level up your skills, find teammates and level up on the platform.`}
            />
            <EventsDescriptionCard
                title={'Showcase Series'}
                description={`
                Our Showcase Series is a recruiting tournament comprising individual game titles and co-hosted 
                with one of our recruiting partners. Students play virtually in front of recruiters from leading 
                collegiate programs in real-time via live streams. Recruiting hosts typically engage with players 
                directly to make connections and deepen the relationship between students and colleges.`}
            />
            <EventsDescriptionCard
                title={'Carry2College'}
                description={`
                Our Carry2College (C2C) event is a three day marquee recruiting event hosted four times a year. 
                This online event features a heavy presence from collegiate recruiters across the country along 
                with inside and outside the game opportunities such as educational panels, job fairs, panels to 
                help your parents understand the opportunities around esports and gaming, tournament play and a 
                unique broadcast to capture all the action. One on one sessions with recruiters are available 
                through the weekend as well as discussions around career opportunities in esports, gaming and 
                related fields.
                `}
            />
        </div>
    );
};
